import Vue from 'vue';
import App from './App.vue';

// eslint-disable-next-line
import styles from './scss/main.scss';

Vue.config.productionTip = false;

// axios
import axios from './axios.js';
Vue.prototype.$http = axios;

// Vue Router
import router from './router';

import jwt from '@/http/requests/auth/jwt/index.js';
jwt.init(router);

// Vuex Store
import store from './store';

// Globala komponenter. g for global
import Button from '@/components/Button';
Vue.component('g-button', Button);

import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
Vue.component('g-calendar', Calendar);
Vue.component('g-date-picker', DatePicker);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
